function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.854902 0 0 0 0 0.850980 0 0 0 0 0.870588 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pagina's---Web-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "search_black_24dp",
  transform: "translate(-1201.000000, -261.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1198.000000, 258.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 31.4825532 0 31.4825532 31.4825532 0 31.4825532"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3324823,18.3648227 L19.2961816,18.3648227 L18.9288851,18.010644 C20.2144227,16.5152227 20.9883688,14.5737986 20.9883688,12.461844 C20.9883688,7.75257872 17.1711092,3.93531915 12.461844,3.93531915 C7.75257872,3.93531915 3.93531915,7.75257872 3.93531915,12.461844 C3.93531915,17.1711092 7.75257872,20.9883688 12.461844,20.9883688 C14.5737986,20.9883688 16.5152227,20.2144227 18.010644,18.9288851 L18.3648227,19.2961816 L18.3648227,20.3324823 L24.9236879,26.8782298 L26.8782298,24.9236879 L20.3324823,18.3648227 Z M12.461844,18.3648227 C9.19552908,18.3648227 6.55886525,15.7281589 6.55886525,12.461844 C6.55886525,9.19552908 9.19552908,6.55886525 12.461844,6.55886525 C15.7281589,6.55886525 18.3648227,9.19552908 18.3648227,12.461844 C18.3648227,15.7281589 15.7281589,18.3648227 12.461844,18.3648227 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}))));

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.27498152.svg";
export { ForwardRef as ReactComponent };